import { Button, Card, CardContent, Typography } from '@material-ui/core';
import * as _ from 'lodash';
import * as queryString from 'query-string';
import * as React from 'react';
import { injectIntl } from 'react-intl';

import { AccountLevelEnum, SignUpModeEnum, SnackBarVariants } from '@app/app.enum';
import { history } from '@app/app.routes';
import store from '@app/app.store';
import * as maerskLogo from '@app/assets/images/maersk-logo-rgb.svg';
import { withAxiosCancellation } from '@app/components/core/axios-cancel.component';
import withSnackBar from '@app/components/core/message.component';
import * as models from '@app/models/index';
import Injector from '@app/services';
import { AccountService } from '@app/services/account.service';
import { SharedService } from '@app/services/shared.service';
import SignUpFormComponent from './sign-up-form.component';

const accountService: AccountService = Injector.get(AccountService);
const sharedService: SharedService = Injector.get(SharedService);

class SignupComponent extends React.Component<models.ISignUpComponentProps, models.IAuthState> {
	constructor(props: models.ISignUpComponentProps) {
		super(props);
		this.state = models.initialAuthState(accountService.IsAuthorized);
	}

	public componentDidMount() {
		if (this.props.location.search) {
			this.getQueryParams();
		}
	}

	public render() {
		return (
			<main className='sign-up-root'>
				<div className='text-center pb-2'>
					<div className='genesis-text'>
						<img src={maerskLogo} className='genesis-logo-signin-signup' />
					</div>
				</div>
				<Card>
					<CardContent>
						<div className='text-center'>
							<Typography component='h3' variant='h6'>
								{this.props.intl.formatMessage({
									id: 'app.signup.signup-box-heading-customer',
								})}
							</Typography>
						</div>
						<SignUpFormComponent
							signUpKey={this.state.signupKey}
							parentAccountId={this.state.parentAccountId}
							partnerAppId={this.state.partnerAppId}
							mode={SignUpModeEnum.Normal}
							onSignUp={(result: models.IUserSignInResponse, formData?: models.ISignUpFormFields, error?: any) => {
								// If error then show the error message inside snackbar
								if (error) {
									this.openSnackbar(sharedService.parseError(error.data), SnackBarVariants.Error);
									return;
								}

								// Set authentication status in case if error comes null
								this.props.onUserSignUp({
									isAuthenticated: true,
									user: result.user,
									apiKey: result.apiKey,
									status: result.status,
								});

								this.redirectToDashboard();
							}}
						/>
					</CardContent>
				</Card>
				<div className='text-center pt-2 outer-card-area'>
					<div>
						{this.props.intl.formatMessage({
							id: 'app.signup.signin-suggest-text',
						})}
					</div>
					<div className='pt-1'>
						<Button type='button' variant='outlined' onClick={this.navigateToSignIn}>
							{this.props.intl.formatMessage({
								id: 'app.signup.signin-suggest-button-text',
							})}
						</Button>
					</div>
				</div>
			</main>
		);
	}

	// open  snackbar
	public openSnackbar = (message: string | string[], variantName: SnackBarVariants) => {
		this.setState({
			isAuthenticated: store.getState().authentication.isAuthenticated,
			loading: false,
		});
		this.props.openSnackBar(message, variantName);
	};

	private navigateToSignIn = () => {
		if (this.state.partnerAppId) {
			const param: string = queryString.stringify({
				partnerAppId: this.state.partnerAppId,
				parentAccountId: this.state.parentAccountId,
			});
			history.push('/signin?' + param);
			return;
		}
		history.push('/signin');
	};

	private redirectToDashboard() {
		history.push(models.Module.Dashboard.url);
	}

	private getQueryParams() {
		// Making all the keys of query-string parsed object to lowercase so to ignore casing in matching query params
		const queryParams = _.mapKeys(queryString.parse(this.props.location.search), (value, key) => key.toLowerCase());
		const accountLevel = AccountLevelEnum.Customer;
		const signupKey = queryParams.signupkey && queryParams.signupkey.toString();
		this.setState({
			partnerAppId: queryParams.partnerappid && queryParams.partnerappid.toString(),
			parentAccountId: queryParams.parentaccountid && queryParams.parentaccountid.toString(),
			signupKey,
			isSignUpKeyInQueryParam: !!signupKey,
			email: queryParams.email && queryParams.email.toString(),
			accountLevel,
		});
	}
}

export default withAxiosCancellation(withSnackBar(injectIntl(SignupComponent)));



// WEBPACK FOOTER //
// ./src/components/account/signup/signup.component.tsx